import React from "react";
import { Card } from "@shopify/polaris";
import { Col, Row } from "reactstrap";
import oberlo from "../../assets/integrations/oberlo.png";
import aliexpress from "../../assets/integrations/aliexpress.png";
import Layout from "./Layout";
const Fulfillment = () => {
  const listCheckout = [
    {
      title: "Sell Your Products Easily",
      description: "Where Self Made is Made",
      logo: oberlo,
      crispEvent: "Oberlo",
    },
    {
      title: "Easy Online Shopping",
      description: "Smater Shopping, Better Living",
      logo: aliexpress,
      crispEvent: "AliExpress",
    },
  ];
  return (
    <div style={{ marginTop: "10px" }}>
      <Card sectioned title="Fulfillment">
        <Row>
          {listCheckout.map((item, index) => {
            return (
              <Col md="4">
                <Layout
                  title={item.title}
                  description={item.description}
                  logo={item.logo}
                  crispEvent={item.crispEvent}
                />
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export default Fulfillment;
